"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultRenderStreamingConfiguration_1 = require("./defaults/DefaultRenderStreamingConfiguration");
const AbstractCommand_1 = __importDefault(require("./command/AbstractCommand"));
const RenderStreamingStatus_1 = require("./RenderStreamingStatus");
const CommandMessageType_1 = require("./CommandMessageType");
const RenderStreamingCallback_1 = __importDefault(require("./RenderStreamingCallback"));
const lib_pixelstreamingfrontend_ue5_3_1 = require("@epicgames-ps/lib-pixelstreamingfrontend-ue5.3");
class RenderStreamingManager extends RenderStreamingCallback_1.default {
    UE_COMMAND_CALLBACK_NAME = "OnCommandResponse";
    status = RenderStreamingStatus_1.RenderStreamingStatus.disconnected;
    _messageType = CommandMessageType_1.CommandMessageType.COMMAND;
    _pixelStreaming;
    commandCallbackTable = {};
    anyCommandCallbackTable = [];
    _onStatusChangedCallback = (o, n) => { };
    constructor(url = DefaultRenderStreamingConfiguration_1.DefaultRenderStreamingConfiguration) {
        super();
        const config = new lib_pixelstreamingfrontend_ue5_3_1.Config({ useUrlParams: false });
        config.setFlagEnabled(lib_pixelstreamingfrontend_ue5_3_1.Flags.MouseInput, false);
        config.setFlagEnabled(lib_pixelstreamingfrontend_ue5_3_1.Flags.KeyboardInput, false);
        config.setFlagEnabled(lib_pixelstreamingfrontend_ue5_3_1.Flags.TouchInput, false);
        config.setFlagEnabled(lib_pixelstreamingfrontend_ue5_3_1.Flags.GamepadInput, false);
        config.setFlagEnabled(lib_pixelstreamingfrontend_ue5_3_1.Flags.XRControllerInput, false);
        config.setFlagEnabled(lib_pixelstreamingfrontend_ue5_3_1.Flags.AutoPlayVideo, true);
        config.setFlagEnabled(lib_pixelstreamingfrontend_ue5_3_1.Flags.StartVideoMuted, true);
        const stream = new lib_pixelstreamingfrontend_ue5_3_1.PixelStreaming(config);
        this._pixelStreaming = stream;
        document
            .getElementById("player")
            .appendChild(this._pixelStreaming.videoElementParent);
        if (!window.signallingURL) {
            var matchMakerRequest = new XMLHttpRequest();
            matchMakerRequest.open("GET", `${url.matchmaker?.domain}:${url.matchmaker?.port}`, false);
            matchMakerRequest.send();
            console.log(matchMakerRequest.responseText);
            if (matchMakerRequest.responseText === "{}") {
                console.log("No signaling server available");
                try {
                    window.dispatchEvent(new CustomEvent("signalingServersNotAvailable"));
                }
                catch (e) {
                    console.warn("_pixelStream.dispatchEvent does not exist.");
                    window.dispatchEvent(new CustomEvent("noSignalingServerAvaialbe"));
                }
                return;
            }
            console.log(JSON.parse(matchMakerRequest.responseText));
            var sigMessage = JSON.parse(matchMakerRequest.responseText);
            console.log(sigMessage.signallingURL);
            window.signallingURL = window.signallingURL
                ? window.signallingURL
                : sigMessage.signallingURL;
            setInterval(function () {
                window.signallingURL = "";
            }, 2000);
        }
        var signallingServerURL = window.signallingURL;
        stream.setSignallingUrlBuilder(() => signallingServerURL);
        stream.addEventListener("dataChannelOpen", (e) => {
            this._onRenderStreamingReady();
        });
        stream.addResponseEventListener(this.UE_COMMAND_CALLBACK_NAME, (dataString) => {
            console.log(`Received command response: ${dataString}`);
            var message = JSON.parse(dataString);
            var payloadString = JSON.stringify(message.Payload);
            console.log(`Sending to command callback table: ${dataString}`);
            this.anyCommandCallbackTable.forEach((element) => {
                element(dataString);
            });
            if (this.commandCallbackTable[message.CommandName]) {
                this.commandCallbackTable[message.CommandName](dataString);
            }
        });
    }
    setMessageType(msgType) {
        this._messageType = msgType;
    }
    onStatusChanged(callback) {
        this._onStatusChangedCallback = callback;
    }
    startStreaming() {
        this._pixelStreaming.connect();
    }
    setupMatchmaker() { }
    createVideoPlayer() { }
    sendClickEvent(elementId) { }
    executeCommand(command) {
        this._pixelStreaming.emitUIInteraction({
            CommandName: command.name,
            Parameter: command.parameters,
        });
    }
    onCommandResponse(command, callback) {
        if (command instanceof AbstractCommand_1.default) {
            this.commandCallbackTable[command.name] = callback;
        }
        else {
            this.commandCallbackTable[command] = callback;
        }
    }
    onAnyCommand(callback) {
        this.anyCommandCallbackTable.push(callback);
    }
    send(commandName, param) { }
    async disconnect() {
        this._pixelStreaming.removeResponseEventListener(this.UE_COMMAND_CALLBACK_NAME);
        this._pixelStreaming.disconnect();
    }
}
exports.default = RenderStreamingManager;
